<div class="ngx-modal-header">
    <h4 class="modal-title pull-left">{{modalData.title}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <app-entity-activities [companyId]="modalData.companyId" [activityMap]="modalData.activityMap"
                                    [isSharedClient]="modalData.isSharedClient" [context]="modalData.context">
            </app-entity-activities>
        </div>
    </div>
</div>
